import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="terms">
      <Header />
      <main className="terms-main">
        <div className="page-header">
          <div className="page-header-inner">
            <div className="breadcrumb">
              <Link to="/" onClick={toTop}>
                Legal
              </Link>
            </div>
            <h1 className="page-title">Terms of use</h1>
          </div>
        </div>
        <div className="page-content">
          <p className="last-updated">Last Update: September 22nd, 2023</p>
          <div className="customer-service-content-inner">
            <div className="customer-service-body">
              <p>
                The following Terms of Use (“Terms”) are entered into by and
                between you and MillerKnoll, Inc. (“MillerKnoll,” “We,” “Our” or
                “Us”) and governs your access to and use of any MillerKnoll
                websites, mobile applications, or other interactive products,
                programs, or services (each, a “Site,” or collectively, the
                “Sites”), including any content, functionality, and services
                offered on or through the Sites, whether as a guest or a
                registered user. The Sites are owned and operated by MillerKnoll
                on behalf of itself and for its subsidiaries and affiliates, and
                are offered and available to users who are 16 years of age or
                older and the age of majority in the jurisdiction in which they
                reside, and reside in the United States or any of its
                territories or possessions. These Terms do not affect your
                statutory rights. By accessing, using, or registering for a
                Site, you agree to be bound by these Terms, which and govern all
                transactions via the Site or over a telephone. If you are
                unwilling to be bound by these Terms, you should not access,
                use, or register for a Site. Please also consult our Privacy
                Notice for a description of our privacy practices and policies
                as well as each individual Site for additional terms and
                conditions governing your use of such Site, including, but not
                limited to, any selling policies and/or terms of sales governing
                any use and/or purchase of any products, programs, or services,
                which are expressly incorporated herein. We also recommend that
                you print and retain a copy of these Terms for future reference.
              </p>
              <p>
                NOTICE REGARDING DISPUTE RESOLUTION: THESE TERMS CONTAIN TERMS
                THAT GOVERN HOW CLAIMS BETWEEN YOU AND US RELATING TO YOUR USE
                OF OUR SITES WILL BE RESOLVED. FOR EXAMPLE, THESE TERMS CONTAIN
                AN ARBITRATION AGREEMENT AND WAIVER OF CLASS ACTION WHICH STATES
                THAT WE MUST ARBITRATE INSTEAD OF GOING TO A COURT BEFORE A
                JUDGE AND JURY AND THAT ALL SUCH ARBITRATION CLAIMS MUST BE
                BROUGHT IN YOUR INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR
                CLASS REPRESENTATIVE OR MEMBER OR OTHERWISE ON BEHALF OF OTHERS
                IN ANY PURPORTED CLASS, COLLECTIVE OR REPRESENTATIVE.
              </p>
              <h3>Contact Information</h3>
              <p>
                Mailing Address: MillerKnoll, Inc., 855 East Main Ave., Zeeland,
                MI 49464
              </p>
              <p>Please consult each Site for additional ways to contact us.</p>
              <h3>Geographic Restrictions</h3>
              <p>
                The owner of the Sites is based in the State of Michigan in the
                United States. We make no claims that the Sites or any of its
                content is accessible or appropriate outside of the United
                States or compliant with the laws or regulations of any country
                but the United States. Access to the Sites may not be legal by
                certain persons or in certain countries. If you access the Sites
                from outside the United States, you do so on your own initiative
                and are responsible for compliance with local laws.
              </p>
              <h3>Changes to the Terms</h3>
              <p>
                We reserve the right to modify these Terms at any time without
                notice to you, including imposing a fee to access certain
                materials contained on the Sites. Any change in these Terms are
                effective immediately upon posting. Accordingly, MillerKnoll
                recommends that you read these terms carefully each time you
                visit a Site. Any use of the Sites after changes have been made
                shall be deemed acceptance of those changed Terms.
              </p>
              <h3>Access to the Sites</h3>
              <p>
                You acknowledge and agree that the Sites, including the
                accessibility, hours of use, and any and all features and
                content available via the Sites and any User Content (as defined
                below), may be modified by Us, in Our sole discretion, at any
                time without prior notice. We may restrict access to any or all
                portions of the Sites or remove any information or content from
                the Sites at any time. All such modifications are subject to
                these Terms. We will not be liable if for any reason all or any
                part of the Sites are unavailable at any time or for any period.
              </p>
              <h3>Intellectual Property Rights</h3>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Terms;
